import { tierFactTimelineTier2API, tierFactTimelineTier3API, workTaskFactReasonReportAPI } from "./api";

export const tier2GetGprDeviation = async (sbs_project_id, date_begin, date_end) => {
  try {
    if (!sbs_project_id || !date_begin || !date_end) return [];
    const res = await tierFactTimelineTier2API.getGprDeviation(
      sbs_project_id,
      date_begin,
      date_end
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const tier2GetLaborSum = async (sbs_project_id, date_begin, date_end) => {
  try {
    if (!sbs_project_id || !date_begin || !date_end) return [];
    const res = await tierFactTimelineTier2API.getLaborSum(
      sbs_project_id,
      date_begin,
      date_end
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const tier2GetReasons = async (sbs_project_id, date_begin, date_end) => {
  try {
    // sbs_project_id обязателен, date_begin/date_end могут быть null (показать все)
    if (!sbs_project_id) return [];
    const res = await tierFactTimelineTier2API.getReasons(
      sbs_project_id,
      date_begin,
      date_end
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};


// ========== Tier 3 ==========

export const tier3GetDeviation = async (date_begin, date_end) => {
  try {
    if (!date_begin || !date_end) return [];
    const res = await tierFactTimelineTier3API.getDeviation(date_begin, date_end);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const tier3GetLaborSum = async (date_begin, date_end) => {
  try {
    if (!date_begin || !date_end) return [];
    const res = await tierFactTimelineTier3API.getLaborSum(date_begin, date_end);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const tier3GetReasons = async (date_begin, date_end) => {
  try {
    // date_begin/date_end могут быть null (показать все)
    const res = await tierFactTimelineTier3API.getReasons(date_begin, date_end);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getWorkTaskFactReasonReport = async (sbs_project_id, block_id, date_begin, date_end) => {
  try {
    const res = await workTaskFactReasonReportAPI.getReport(sbs_project_id, block_id, date_begin, date_end);
    return res?.data || [];
  } catch (e) {
    console.error("Error fetching reason report:", e);
    return [];
  }
};


